export default {
  placementText: {
    fontSize: 34,
  },
};
